import { useEffect, useState } from 'react';

function FixedImage({ src, alt, width, height }) {
  const [loaded, setLoaded] = useState();
  const placeholder = generateImagePlaceholder(width, height)

  return (
    <>
      <img
        src={placeholder}
        style={{
          objectFit: "cover",
          objectPosition: "center",
          maxWidth: "100%",
          maxHeight: "100%",
          width: width,
          height: "auto",
          display: !loaded ? "inline-block" : "none",
        }}
      ></img>
      <img
        style={{
          objectFit: "cover",
          objectPosition: "center",
          maxWidth: "100%",
          maxHeight: "100%",
          height: "auto",
          display: loaded ? "inline-block" : "none",
        }}
        onLoad={() => {
          setLoaded(true)
        }}
        src={src}
        alt={alt} />
    </>
  );


  /**
   * 
   * @param {number} width 
   * @param {number} height 
   * @returns {string}
   */
  function generateImagePlaceholder(width, height) {
    return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}"%3E%3C/svg%3E`
  }
}

export default FixedImage;